import React, { useEffect } from "react"
import { FiChevronRight, FiArrowRight } from "react-icons/fi"
import { Link } from "gatsby"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const motionSection = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      // when: "beforeChildren",
    },
  },
}

const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}

const list = ({ block }) => {
  const { heading, listItems } = block

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      <div className="p-6 lg:p-12 container max-w-screen-lg mx-auto">
        <h2 className="h2 text-center relative w-fit mx-auto mb-8">
          <motion.div variants={title}>{heading}</motion.div>
          <motion.div
            variants={underline}
            className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
          />
        </h2>

        <div className="grid divide-y divide-black">
          {listItems.map((item, index) => (
            <motion.div variants={motionItems} className="px-4 py-8 grid gap-2">
              <div className="badge badge-success">{item.status}</div>
              <h3 className="text-lg font-semibold">{item.title}</h3>
              <a href={item.addressURL}>{item.address}</a>

              {/* <p>{item.link.slug.current}</p> */}
              {item.link && (
                <div>
                  <Link to={item.link.slug.current} className="btn-underline btn-underline--dark">
                    <div className="flex gap-2 items-center">
                      <span>View this location</span> <FiArrowRight />
                    </div>
                  </Link>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  )
}

export default list
